import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AlertLayer from "../components/AlertLayer";
import AmwalyPortfolio from "../components/AmwalyPortfolio";


const AmwalyPortfolioPage = () => {
  return (
    <>
      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="Amwaly Portfolio" />

        {/* AlertLayer */}
        <AmwalyPortfolio />


    </>
  );
};

export default AmwalyPortfolioPage;
